import React, { useState } from 'react'
import { getToken } from '../../lib/auth'

type Props = {
  replyTo?: { id: string | number; name: string | null } | null
  onCancelReply?: () => void
  onSubmit: (body: string, parentId?: string | number | null) => Promise<void>
}

export default function CommentComposer({ replyTo, onCancelReply, onSubmit }: Props) {
  const authed = Boolean(getToken())
  const [text, setText] = useState('')
  const [submitting, setSubmitting] = useState(false)

  async function handleSend() {
    const body = text.trim()
    if (!body) return
    setSubmitting(true)
    try {
      await onSubmit(body, replyTo?.id ?? null)
      setText('')
    } finally {
      setSubmitting(false)
    }
  }

  if (!authed) {
    return (
      <div className="p-3 border-t border-white/10">
        <a href="/login" className="text-sm text-white/85 underline">Log in to comment</a>
      </div>
    )
  }

  return (
    <div className="p-3 border-t border-white/10">
      {replyTo?.name && (
        <div className="mb-2 flex items-center gap-2 text-xs text-white/80">
          <div className="px-2 py-1 rounded-full bg-white/10">Replying to {replyTo.name}</div>
          {onCancelReply && (
            <button onClick={onCancelReply} className="text-white/70 hover:text-white/90">Cancel</button>
          )}
        </div>
      )}
      <div className="flex items-end gap-2">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Write a comment…"
          rows={2}
          className="flex-1 resize-none rounded-lg bg-white/5 border border-white/10 px-3 py-2 outline-none focus:ring-2 focus:ring-brand chat-scroll"
        />
        <button
          onClick={handleSend}
          disabled={submitting || !text.trim()}
          className="px-3 py-2 rounded-lg bg-brand/80 hover:bg-brand disabled:opacity-60"
        >
          Send
        </button>
      </div>
    </div>
  )
}

